import { ApolloError } from "@apollo/client";

export interface FieldErrorMap {
  email?: string;
  password?: string;
  submit?: string;
}

/**
 * Maps server-side authentication errors to specific form field errors.
 * The function is intentionally minimal – extend when back-end adds error codes.
 */
export const mapAuthError = (error: ApolloError): FieldErrorMap => {
  const msg = error?.graphQLErrors?.[0]?.message || error.message || "";
  const lowered = msg.toLowerCase();

  if (lowered.includes("credentials") && lowered.includes("found")) {
    // No user for given email
    return { email: "E-Mail unbekannt" };
  }

  if (lowered.includes("invalid password")) {
    return { password: "Falsches Passwort" };
  }

  if (lowered.includes("already in use")) {
    return { email: "E-Mail bereits vergeben" };
  }

  // Any message that references password => show raw message in helper text
  if (lowered.includes("password") || lowered.includes("passwort")) {
    return { password: msg };
  }

  // Fallback – attach message as submit-level error so it's visible somewhere
  return { submit: msg || "Unbekannter Fehler" };
}; 